export const CHAT = {
  page: 'chat-page',
  backBtn: 'chat-back-btn',
  categoryTitle: 'chat-category-title',
  messagesList: 'chat-messages-list',
  input: 'chat-input',
  sendBtn: 'chat-send-btn',
  userMessage: 'chat-user-message',
  assistantMessage: 'chat-assistant-message',
  source: 'chat-source-badge',
};
